export default "__VITE_ASSET__980711cd__"